import React from 'react';

const WidgetDocumentSearchFormModal = React.lazy(() => import('../components/FormModal'));
const widgetDocumentSearchModalRegistry = {
    search_widgetDocumentSearchId: WidgetDocumentSearchFormModal
};
export default widgetDocumentSearchModalRegistry;
